import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '@carm/_core/baseapi.service';
import {
  IGetGoodsResponse,
  IDDBGoodsRequest,
  IDDBGoodsResponse,
} from '../models/api';
import { HttpParams } from '@angular/common/http';
import { DutyDrawbackDraftService } from './ddb-draft.service';

@Injectable()
export class AsyncValidationService extends BaseApiService {
  constructor(
    protected injector: Injector,
    public ddbDraftService: DutyDrawbackDraftService,
  ) {
    super(injector);
  }

  validateTransaction(
    bn15: string,
    transactionNumber: string
  ): Observable<boolean> {
    const endPoint = `${this.endPointBP}/cad/declaration/importer/${bn15}/transaction/${transactionNumber}`;
    return this.httpGet<any>(endPoint);
  }

  validateB3Transaction(
    transactionNumber: string,
    isImporter: boolean,
    bn15: string
  ): Observable<boolean> {
    let BN15 = bn15;
    if (isImporter) {
      this.carmRouter.bn15$.subscribe(programId => {
        BN15 = programId;
      });
    }
    const endPoint = `${this.endPointBP}/cad/declaration/bn15/${BN15}/b3/${transactionNumber}`;
    return this.httpGet<any>(endPoint);
  }

  validateLine(
    declarationUid: string,
    goodLineNo: string
  ): Observable<IGetGoodsResponse> {
    const params = new HttpParams()
      .set('currentPage', '1')
      .set('pageSize', '10')
      .set('searchString', '')
      .set('goodLineNo', goodLineNo);
    const endPoint = `${this.endPointBP}/cad/declaration/${declarationUid}/goods`;
    return this.httpAuthGet<IGetGoodsResponse>(endPoint, params);
  }

  validateGood(
    draftUid: string,
    payload: IDDBGoodsRequest
  ): Observable<IDDBGoodsResponse> {
    return this.ddbDraftService.addGoods(draftUid, payload);
  }
}
